<template>
  <div
    class="editor-page-drawer-thumbnail"
    :style="thumbnailUrl ? {
      backgroundImage: `url(${thumbnailUrl})`,
    } : undefined"
    :class="{
      'editor-page-drawer-thumbnail--default': !thumbnailUrl,
    }"
  />
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      thumbnailUrl: null,
    };
  },
  created() {
    this.loadThumbnail();
  },
  watch: {
    url() {
      this.loadThumbnail();
    },
  },
  methods: {
    loadThumbnail() {
      if (!this.url) {
        this.thumbnailUrl = null;
        this.image = null;
        return;
      }
      const image = new Image();
      this.image = image;
      image.onload = () => {
        if (image !== this.image) return;
        this.thumbnailUrl = this.url;
      };
      image.onerror = () => {
        if (image !== this.image) return;
        this.thumbnailUrl = null;
      };
      image.src = this.url;
    },
  },
};
</script>

<style lang="stylus">
.editor-page-drawer-thumbnail {
  aspect-ratio: 1000 / 544;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 118%;
  border-radius: $nebula-border-radius-small;
  overflow: hidden;
  width: 100%;

  &--default {
    background-color: #404858; // Match blank_board.png background
    background-image: url('../assets/blank_board.png');
    background-size: 90%;
  }
}
</style>
